<span class="badge badge-pill badge-small badge-light"
  *ngIf="assignment.AcceptanceStatus == 'None' && assignment.InterestedStatus != 'Revoked'">
  <i class="fas me-1 fa-user"></i>
  {{ texts.presented[language] }}
</span>

<span class="badge badge-pill badge-small badge-light"
  *ngIf="assignment.AcceptanceStatus == 'Accepted' && assignment.InterestedStatus != 'Revoked' && !assignment.IsHired">
  <i class="fas me-1 fa-comment-alt"></i>
  {{ texts.firstInterview[language] }}
</span>

<span class="badge badge-pill badge-small badge-danger-soft"
  *ngIf="assignment.InterestedStatus == 'Revoked' && !assignment.IsHired">
  <i class="fas me-1 fa-times-circle"></i>
  {{ texts.applicationWithdrawn[language] }}
</span>

<span class="badge badge-pill badge-small badge-danger-soft"
   *ngIf="assignment.AcceptanceStatus == 'Rejected' && !assignment.IsHired">
  <i class="fas me-1 fa-times-circle"></i>
  {{ texts.rejected[language] }}
</span>

<span class="badge badge-status badge-pill badge-small badge-success-soft"
  *ngIf="assignment.IsHired">
  <i class="fas me-1 fa-check-circle"></i>
  {{ texts.hired[language] }}
</span>
